import {getDistance} from '../../../static/js/lib/utilities';

const DURATION = 300; // length of animation in milliseconds
// pages that have white backgrounds
const LIGHT_PAGES = [
  '/contact/',
  '/thesis/',
  '/investments/',
];
const $docElement = document.documentElement;

/**
 * check if page is a light page
 * @return {Boolean}
 */
function getIsLightPage() {
  const {pathname} = window.location;
  if (pathname !== '/') {
    return LIGHT_PAGES.includes(pathname);
  }
  // for homepage, check theme-inverse on visible section
  const $selectedFixedSection = document.querySelector('.homepageFixedSection.isSelected');
  if ($selectedFixedSection) {
    return !$selectedFixedSection.classList.contains('theme-inverse');
  }
}

export default class PageCurtain {
  constructor($element) {
    // get elements
    this.$element = $element;
    this.$svg = $element.querySelector('.pageCurtain__svg');
    this.$positiveEllipse = $element.querySelector('.pageCurtain__positiveEllipse');
    this.$negativeEllipse = $element.querySelector('.pageCurtain__negativeEllipse');
    this.$maskRect = $element.querySelector('.pageCurtain__maskRect');
    // bind methods
    this.animateIntro = this.animateIntro.bind(this);
    this.animateOutro = this.animateOutro.bind(this);
  }

  updateMeasurements() {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const windowDiagonal = getDistance( windowWidth, windowHeight );
    this.radius = windowDiagonal/2;

    this.$svg.setAttribute('viewBox', `0 0 ${windowWidth} ${windowHeight}`);

    [this.$svg, this.$maskRect].forEach(($node) => {
      $node.setAttribute('width', windowWidth);
      $node.setAttribute('height', windowHeight);
    });

    [this.$positiveEllipse, this.$negativeEllipse].forEach(($ellipse) => {
      $ellipse.setAttribute('cx', windowWidth/2);
      $ellipse.setAttribute('cy', windowHeight/2);
    });
  }

  // "out" = out of current page
  startOutro(onOutroEnd) {
    this.updateMeasurements();
    this.$element.style.display = 'block';
    $docElement.classList.add('isPageCurtaining');
    // set inverse theme on light pages
    const isLightPage = getIsLightPage();
    if (isLightPage) this.$element.classList.add('theme-inverse');

    this.outroStartTime = new Date();
    this.onOutroEnd = onOutroEnd; // callback
    this.animateOutro();
  }

  animateOutro() {
    const nowTime = new Date();
    const elapsed = nowTime - this.outroStartTime;
    const progress = elapsed / DURATION;
    this.renderEllipse(this.$positiveEllipse, progress);

    if (progress <= 1) {
      requestAnimationFrame(this.animateOutro);
    } else {
      // outro end
      this.$element.classList.add('isLoading');
      if (this.onOutroEnd) this.onOutroEnd();
    }
  }

  // "in" = into new page
  startIntro(onIntroEnd) {
    this.introStartTime = new Date();
    this.onIntroEnd = onIntroEnd; // callback
    this.$element.classList.remove('isLoading');
    this.animateIntro();
  }

  animateIntro() {
    const nowTime = new Date();
    const elapsed = nowTime - this.introStartTime;
    const progress = elapsed / DURATION;
    this.renderEllipse(this.$negativeEllipse, progress);

    if (progress <= 1) {
      requestAnimationFrame(this.animateIntro);
    } else {
      // reset values
      this.endAnimation();
      if (this.onIntroEnd) this.onIntroEnd();
    }
  }

  endAnimation() {
    [this.$positiveEllipse, this.$negativeEllipse].forEach(($ellipse) => {
      $ellipse.setAttribute('rx', 0);
      $ellipse.setAttribute('ry', 0);
    });
    this.$element.style.display = 'none';
    $docElement.classList.remove('isPageCurtaining');
    this.$element.classList.remove('theme-inverse');
  }

  renderEllipse($ellipse, progress) {
    const easeProgress = progress * progress * progress;
    const radius = easeProgress * this.radius;
    $ellipse.setAttribute( 'rx', radius );
    $ellipse.setAttribute( 'ry', radius );
  }
}
